<template>
  <div class="centered">
    <div>
      <h1>The server is currently unavailable</h1>
      <p>
        Your page should be automatically refreshed once the connection is
        reestablished.<br />If this is not the case, click
        <router-link :to="link">here</router-link> to continue where you left
        off.
      </p>
    </div>
  </div>
</template>

<script>
import { StatusAPI } from "@/lib/api"
import { timer } from "vue-timers"

export default {
  timers: { timeout: { time: 1000 * 10, autostart: true, repeat: true } },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from
    })
  },
  data: function() {
    return {
      previousRoute: undefined
    }
  },
  computed: {
    link: function() {
      return this.previousRoute ? this.previousRoute : ""
    }
  },
  methods: {
    timeout() {
      StatusAPI.get().then(() => {
        this.$router.replace(this.previousRoute)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
div.centered {
  width: 100%;
  height: 100%;
  flex-direction: columns;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
